/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityProviderAttributeMapping { 
    /**
     * Mapping claim type.
     */
    claimType: string;
    /**
     * Indicates whether mapping claim name can be identified automatically.
     */
    allowAliases?: boolean;
    /**
     * User parameter to which a claim type is mapped.
     */
    attribute: IdentityProviderAttributeMappingAttribute;
    /**
     * Default attribute value.
     */
    defaultValue?: string | null;
}
export enum IdentityProviderAttributeMappingAttribute {
    Unknown = 'Unknown',
    FirstName = 'FirstName',
    LastName = 'LastName',
    Name = 'Name',
    Address = 'Address',
    Phone = 'Phone'
};



